/* eslint-disable func-names, max-len, no-underscore-dangle */

if ($('input[type=checkbox]').length > 0) {
  // reload on partial postback
  const prm = Sys.WebForms.PageRequestManager.getInstance();
  if (prm !== null) {
    prm.add_endRequest((sender) => {
      if (sender._postBackSettings.panelsToUpdate !== null) {
        loadCheckboxes();
      }
    });
  }

  $(document).ready(() => {
    loadCheckboxes();
  });
}

function loadCheckboxes() {
  const $checkboxes = $('input[type=checkbox]').not('.js-checkbox-ignore');

  $checkboxes.each(function () {
    const $cb = $(this);
    const $label = $(`label[for=${$cb.attr('id')}]`);

    if ($cb.parent().hasClass('checkbox')) {
      $cb.parent().addClass('clearfix');
    }

    if ($label.length && $label.children('span').length === 0) {
      $label.wrapInner('<p></p>').prepend('<span></span>').addClass('checkLbl');

      $cb.change(() => {
        $label.toggleClass('checked');
      });

      if ($cb.is(':checked')) {
        $label.addClass('checked');
      }
    }
  });
}
